import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export const actionChainProgressEntityAdapter: EntityAdapter = {
  entity: "actionChainProgress",
  isRowActionAllowed: () => false,
};
